"use strict";
import { injected } from "wagmi/connectors";
export const PRIVY_CONNECTOR_ID = "privy-embedded";
export function privyEmbeddedConnector(provider) {
  return injected({
    target: {
      id: PRIVY_CONNECTOR_ID,
      name: "Email (Privy)",
      // Privy's provider and wagmi's expected provider differ only in event-listener variance (a
      // compile-time artifact); both are runtime-compliant EIP-1193 providers, so this cast is sound.
      provider
    },
    shimDisconnect: false
  });
}
